<app-traitement-data titre="Fuites (médiane - 95%)"
    [sousTitre]="patient!.tableauDeBord?.fuitesMediane?.date | aLaDateDu"
    [statut]="(patient!.tableauDeBord?.fuitesMediane | fuitesStatut)">
    {{ (patient!.tableauDeBord?.fuitesMediane?.value | fuites) ?? 'Ø' }} -
    {{ (patient!.tableauDeBord?.fuites95?.value | fuites) ?? 'Ø' }}
</app-traitement-data>